import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// @mui
import { IconButton, Box, List, ListItem, ListItemIcon, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'
import { ContactPhone, Phone, Mail } from '@mui/icons-material'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import Label from '_core/components/Label/Label'

import { withVisitorInfo } from '_core/utils/visitorInfo'

import { Menu } from '_core/components/Menu'

// style
import { contactsPopupStyle } from './contactsPopupStyle'

const RawContactsPopup = (props) => {
  const { classes, inMenu, tooltip, visitorInfo, getLangString: l, ...rest } = props;

  const {
    config: { HAS_CONTACTS_PHONE1, HAS_CONTACTS_PHONE2, HAS_CONTACTS_EMAIL },
  } = useGlobal()


  const buttonRootClasses = clsx({
    [classes.button]: true,
    [classes.buttonContrast]: inMenu,
  })

  const contacts = [
    {
      key: 'phone1',
      enabled: HAS_CONTACTS_PHONE1,
      icon: Phone,
      href: 'tel:' + l('r._.header.contactphone1.link'),
      text: l('r._.header.contactphone1'),
      label: l('r._.header.contactphone1.label'),
    },
    {
      key: 'phone2',
      enabled: HAS_CONTACTS_PHONE2,
      icon: Phone,
      href: 'tel:' + l('r._.header.contactphone2.link'),
      text: l('r._.header.contactphone2'),
      label: l('r._.header.contactphone2.label'),
    },
    {
      key: 'email',
      enabled: HAS_CONTACTS_EMAIL,
      icon: Mail,
      href: 'mailto:' + l('r._.header.contactemail.link'),
      text: l('r._.header.contactemail'),
      label: l('r._.header.contactemail.label'),
    },
  ].filter(contact => contact.enabled)

  return (
    <Menu
      tooltip={l(tooltip)}
      buttonBody={
        <Box component="span" className={classes.buttonIcon}>
          <ContactPhone fontSize="inherit" />
        </Box>
      }
      ButtonComponent={IconButton}

      buttonProps={{
        size: 'large',
        classes: {
          root: buttonRootClasses,
        },
      }}
      content={
        <List className={classes.list} disablePadding>
          {contacts.map(({ key, icon: IconComponent, href, text, label }) => (
            <ListItem key={key} className={classes.ContactsList} disableGutters>
              <ListItemIcon className={classes.ContactsIcon}>
                <IconComponent />
              </ListItemIcon>
              <Box className={classes.ContactsContent}>
                <a className={classes.ContactsPhone} href={href}>
                  <Typography variant="h6" className={classes.ContactsResult}>
                    {text}
                  </Typography>
                </a>
                {label ? (
                  <Label size="small" className={classes.ContactsLabel}>
                    {label}
                  </Label>
                ) : null}
              </Box>
            </ListItem>
          ))}
        </List>
      }
      paperProps={{
        className: classes.paper,
      }}
      popoverProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      }}
      {...rest}
    />
  )
};

RawContactsPopup.defaultProps = {
  tooltip: 'r._.header.contacts',
}

RawContactsPopup.propTypes = {
  inMenu: PropTypes.bool,
  tooltip: PropTypes.string,

  visitorInfo: PropTypes.object.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const ContactsPopup = withVisitorInfo(withLang(
  withStyles(contactsPopupStyle)(RawContactsPopup)
))
